<template lang="pug">
    model-data-table( 
        no-search 
        param-search='period_year' 
        ref='table'
        remind-key='asset-discount-list'
        v-bind='tableProps' 
        @detail='submitDetail' 
        @remove='submitRemove' 
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelDataTable } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import AssetDiscountModel from '@/models/HumanResource/HrAssetDiscount'
    import AssetDiscountFilters from '@/views/HumanResource/HrAssetDiscount/HrAssetDiscountFilters'
    import AssetDiscountHeaders from '@/views/HumanResource/HrAssetDiscount/HrAssetDiscountHeaders'
    //
    export default {
        components: {
            ModelDataTable,
        },
        computed: {

            /**
             *
             */
            ...mapState('SnackbarModalModule', [
                'responseConfirm',
            ]),

            /**
             *
             */
            tableProps() {
                return {
                    filters: AssetDiscountFilters,
                    headers: AssetDiscountHeaders,
                    service: AssetDiscountModel,
                }
            },
        },
        methods: {

            /**
             *
             */
            ...mapActions('MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            /**
             *
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * 
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(AssetDiscountModel, error.response.data))
            },

            /**
             * 
             */
            refresh() {
                this.$refs.table.refresh()
            },

            /**
             * 
             */
            submitCreate() {
                this.$router.push({ name: 'asset-discount-create' })
            },

            /**
             * 
             */
            submitDetail(event) {
                this.$router.push({ 
                    name: 'asset-discount-update', 
                    params: { 
                        id: event.item.id
                    }
                })
            },

            /**
             * 
             */
            submitRemove(event) {

                //
                this.setWarningSnackbar({
                    title: '¿Esta seguro en eliminar el haber o descuento seleccionado?',
                    message: 'Una vez eliminado no se puede recuperar.',
                    confirm: 'eliminar',
                })

                //
                this.selected = event.item
            },

            /**
             * 
             */
            successRemove() {
                this.setSuccessSnackbar('Haber o descuento eliminado exitosamente.')
            },

            /**
             * 
             */
            toRemove() {
                this.selected
                    .delete()
                    .then(this.successRemove)
                    .then(this.refresh)
                    .catch(this.error)
            }
        },
        watch: {

            /**
             * 
             */
            responseConfirm(val) {
                switch(val) {
                    case 'eliminar': return this.toRemove()
                }
            }
        },
        mounted() {
            this.setTitleTopBar('Haberes y descuentos')
            this.setItemsTopBar([
                {
                    text: 'agregar haber o descuento',
                    icon: 'add_circle',
                    action: this.submitCreate,
                }
            ])
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('VIEW_ALL_HOLIDAY')) ctx.$router.push('/')
            })
        },
    }
</script>
